<template lang="pug">
  section#landing
    //- ThreejsScene(:mouse="mouse")
    .landing-texts
      img.landing-title(src="~@/assets/images/landing-title.png")
      img.landing-subtitle(src="~@/assets/images/landing-subtitle.png")
</template>

<script>
// import Post from './Post'
// import BoardBlock from './BoardBlock'
// import ThreejsScene from './ThreejsScene'


export default {
  name: 'Landing',
  props: ['screenSize'],
  data () {
    return {
      datas: [0]
    }
  },
  methods: {
    more: function() {
      let data = 1;
      this.datas.push(data);
    }
  }
}
</script>

<style lang="sass" scoped>
  #landing
    width: 100%
    min-height: 100%
    .landing-texts
      width: 100%
      position: absolute
      left: 0
      bottom: 0
      display: flex
      justify-content: space-between
      align-items: flex-end
      padding: 80px
      pointer-events: none
      .landing-title
        width: 250px
      .landing-subtitle
        width: 400px
      @media screen and (max-width: 600px)
        flex-direction: column
        align-items: flex-start
        justify-content: flex-end
        padding: 30px 10px
        .landing-title
          margin-bottom: 20px
          width: 95%
          max-width: 250px
        .landing-subtitle
          width: 100%
          max-width: 400px

</style>



// WEBPACK FOOTER //
// src/components/Landing.vue